// Import model
import { FilterCompanyRequest } from '../models/FilterCompanyRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CompanyCondition } from '../models/CompanyCondition';
import { CompanyFields } from '../models/CompanyFields';
import { CompanyIndexedFields } from '../models/CompanyIndexedFields';

// Import dependency serializers (for complex types)
import { CompanyConditionSerializer } from './CompanyConditionSerializer';
import { CompanyFieldsSerializer } from './CompanyFieldsSerializer';
import { CompanyIndexedFieldsSerializer } from './CompanyIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCompanyRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterCompanyRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterCompanyRequest instance
   */
  static deserialize(json: string): FilterCompanyRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCompanyRequest instance
   */
  static fromObject(obj: any): FilterCompanyRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCompanyRequest');
    }


    const instance: FilterCompanyRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as CompanyIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as CompanyFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        CompanyConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCompanyRequest instances
   */
  static deserializeArray(json: string): FilterCompanyRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCompanyRequest instance to a JSON string
   */
  static serialize(instance: FilterCompanyRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCompanyRequest instance to a plain object
   */
  static toObject(instance: FilterCompanyRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        CompanyConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterCompanyRequest instances to a JSON string
   */
  static serializeArray(instances: FilterCompanyRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
